<picture>
  <source *ngIf="!webPError" srcset="{{ webPHelper.changeFileToWebP(backgroundUrl) }}" type="image/webp">
  <source srcset="{{ backgroundUrl }}" type="image/jpeg">
  <img class="slider-image" (error)="onError()" src="{{ backgroundUrl }}" alt="File image">
</picture>